import { ReactNode, useState } from 'react'

import Button, { ButtonColor } from '@/components/view/atoms/button/Button'
import Icon, { IconType } from '@/components/view/atoms/icon/Icon'
import { DisclosurePositionHorizon, DisclosurePositionVertical } from '@/components/view/layouts/disclosure/Disclosure'
import DisclosureWrapper from '@/components/view/layouts/disclosure/DisclosureWrapper'

interface Props {
  node?: ReactNode
}

const OperationButton = ({ node }: Props) => {
  const [showing, setShowing] = useState<boolean>(false)
  return (
    <DisclosureWrapper
      disclosureNode={<>{node}</>}
      onClickOutSide={() => setShowing(false)}
      off={!showing}
      horizon={DisclosurePositionHorizon.LEFT}
      vertical={DisclosurePositionVertical.BOTTOM}
    >
      <Button color={ButtonColor.SECONDARY} onClick={() => setShowing(true)} square size='large'>
        <Icon type={IconType.OTHER} />
      </Button>
    </DisclosureWrapper>
  )
}

export default OperationButton
